import  ApiService  from '../../services/api.service';
import HashApi from '../../services/hash.service'
import {TokenService} from '../../services/storage.service';

const state =  {
    response: {
        message: '',
        variant: '',
        errmsg: []
    },
    loading: false,
    isShow: false,
    cmsPageContent: [],
    cmsPages: [],
    homePageBannerText: ''
}

const getters = {
    loading: state => state.loading,
    response: (state) => state.response,
    cmsPageContent: (state) => state.cmsPageContent,
    isShow: (state) => state.isShow,
    cmsPages: (state) => state.cmsPages,
    homePageBannerText: (state) => state.homePageBannerText
}

const actions = {
    setIsShow({ commit }, value) {
        commit('setIsShow', value)
    },
    getCmsPageContent({commit},  pageInfo ) {
        return new Promise((resolve, reject) => {
            
            commit('setLoading', true);
            return new Promise((resolve, reject) => {
                
                ApiService.get('/cms/'+pageInfo.pageName+'?with=["translations"]&locale_id='+pageInfo.lang)
                .then(response => {
                    commit('setCmsPageContent', response.data)
                    resolve();
                })
                .catch(error => {
                    commit('setResponse', error.response.data)
                    reject(error);
                })
                .finally(() => {
                    commit('setLoading', false);
                });
            })
        });
    },
    getHomePageBannerText({commit},  pageInfo ) {
        return new Promise((resolve, reject) => {
            
            commit('setLoading', true);
            return new Promise((resolve, reject) => {
                
                ApiService.get('/cms/'+pageInfo.pageName+'?with=["translations"]&locale_id='+pageInfo.lang)
                .then(response => {
                    commit('setHomePageBannerText', response.data)
                    resolve();
                })
                .catch(error => {
                    commit('setResponse', error.response.data)
                    reject(error);
                })
                .finally(() => {
                    commit('setLoading', false);
                });
            })
        });
    },
    getCmsPages({commit},  pageInfo ) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
                
            ApiService.get('/cms-pages/'+pageInfo.pageType+'?with=["translations"]&locale_id='+pageInfo.lang)
            .then(response => {
                commit('setCmsPages', response.data)
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        })
    },
    
    showError({commit}, value) {
        commit('setError', value)
    },
    resetError({commit}) {
        commit('resetState')
    },
    
}

const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
    setResponse(state, data) {
        state.response.message = data.message;
        if(data.status == 200) {
            state.response.variant = 'success';
        } else {
            state.response.variant = 'danger';
        }
        state.isShow = true;
    },
    setError(state, data) {
        state.isShow = true;
        state.response.variant = 'danger';
        state.response.message = data.msg;
        state.response.errmsg = data.errors;
    },
    
    resetState(state) {
        state.isShow = false;
        state.response.variant = '';
        state.response.message = '';
        state.response.errmsg = [];
    },
    setCmsPageContent(state, value) {

        state.cmsPageContent = value
    },
    setCmsPages(state, value) {
        state.cmsPages = value
    },
    setHomePageBannerText(state, value) {
        state.homePageBannerText = value
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};